import { useContext, useEffect, useState } from "react"
import OrganizationLogo from "../../../components/OrganizationLogo"
import { UserContext } from "../../../context/userContext"
import _ from "lodash"
import { NavLink } from "react-router-dom"
import { useMicroservices } from "../../../hooks/useMicroservices"

export default function SidebarDashboardSupervisor() {
  const userCtx = useContext(UserContext)
  const currentUserRole = Number(userCtx.session.user.staff_role) || null

  const { isMicroserviceEnabled, microservices } = useMicroservices()

  useEffect(() => {
    setItemsList((prevItems) => {
      const newItems = [
        ...prevItems.filter((item) => item.name !== "Kiosk Dashboard"),
      ]
      if (isMicroserviceEnabled(10)) {
        newItems.push({
          name: "Kiosk Dashboard",
          route: "/kiosk-dashboard",
          role: 6,
          active: false,
          iconn: "table_chart",
        })
      }
      return newItems
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [microservices])

  const [actionsMenu, setActionsmenu] = useState("supervision")

  const [itemsList, setItemsList] = useState(() => {
    const baseItems = [
      {
        name: "Organization Dashboard",
        route: "/",
        role: 4,
        active: false,
        iconn: "trending_up",
      },
      {
        name: "Reports",
        route: "/actions/organization-reports",
        role: 3,
        active: false,
        iconn: "analytics",
      },
    ]

    return baseItems
  })

  const [actionsList, setActionsList] = useState([
    {
      name: "Organization Reports",
      route: "/actions/organization-reports",
      role: 3,
      active: false,
    },
    {
      name: "Data Dictionaries",
      route: "/actions/data-dictionaries",
      role: 3,
      active: false,
    },
    {
      name: "View staff needing a Supervision Session",
      route: "/",
      role: 4,
      active: false,
    },
    {
      name: "View staff needing a Supervision Plan",
      route: "/",
      role: 4,
      active: false,
    },
  ])

  const [reportActions, setReportActions] = useState(
    actionsList.filter((action) => action.role < 4)
  )

  const [viewStaffActions, setViewActions] = useState(
    actionsList.filter((action) => action.role >= 4)
  )

  const handleChangeStatus = (boolean) => {
    const updateActions = reportActions.map((action) => {
      return {
        ...action,
        active: boolean,
      }
    })
    setReportActions(updateActions)
  }

  useEffect(() => {
    if (_.isNull(window.localStorage.getItem("ACTIONS_MENU"))) {
      window.localStorage.setItem("ACTIONS_MENU", "organization")
    }
  }, [])

  const handleActiveLink = (e, item) => {
    if (item.name === "Reports") {
      handleChangeStatus(true)
      setActionsmenu("reports")
      window.localStorage.setItem("ACTIONS_MENU", "reports")
    } else {
      handleChangeStatus(false)
      setActionsmenu("supervision")
      window.localStorage.setItem("ACTIONS_MENU", "organization")
    }
  }

  return (
    <div className="sidebar">
      <div className="logo-and-profile-container">
        <OrganizationLogo />
      </div>
      <div className="dashboard-menu-wrapper">
        <div className="container-options">
          <ul>
            {itemsList
              .filter((action) => action.role >= 4)
              .map((filterAction, idx) => (
                <li
                  className="sidebar-dashboard-items"
                  key={idx}
                  onClick={(e) => handleActiveLink(e, filterAction)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleActiveLink(e, filterAction)
                    }
                  }}
                >
                  <NavLink
                    to={filterAction.route}
                    end // Use `end` in React Router v6 (or `exact` in v5)
                    className={({ isActive }) => {
                      return isActive ? "active actions-item" : "actions-item"
                    }}
                  >
                    <span className="material-icons">{filterAction.iconn}</span>
                    <h3>{filterAction.name}</h3>
                  </NavLink>
                </li>
              ))}
            {currentUserRole < 4 &&
              itemsList
                .filter((action) => action.role < 4)
                .map((filterAction, idx) => (
                  <li
                    className="sidebar-dashboard-items"
                    key={idx}
                    onClick={(e) => handleActiveLink(e, filterAction)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleActiveLink(e, filterAction)
                      }
                    }}
                  >
                    <NavLink
                      to={filterAction.route}
                      end // Use `end` in React Router v6 (or `exact` in v5)
                      className={({ isActive }) => {
                        return isActive ? "active actions-item" : "actions-item"
                      }}
                    >
                      <span className="material-icons">
                        {filterAction.iconn}
                      </span>
                      <h3>{filterAction.name}</h3>
                    </NavLink>
                  </li>
                ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
